import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { ATJBot } from './components/ATJBot';
import * as serviceWorker from './serviceWorker';

export type Nullable<T> = T | null;
export type Voidable<T> = T | void;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

ReactDOM.render(<ATJBot />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
